import axios from "axios";
import { getToken, clearToken } from "./token";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BASE}/api`;

const http = axios.create({ baseURL: API, timeout: 30000 });

http.interceptors.request.use((cfg) => {
  // getToken() membuang token luput secara automatik, jadi token mati
  // tidak pernah dihantar ke backend.
  const t = getToken();
  if (t) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${t}`;
  }
  return cfg;
});

http.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401 && !window.location.pathname.startsWith("/aduan")) {
      clearToken();
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export const api = {
  summary: () => http.get("/dashboard/summary").then((r) => r.data),
  infografik: () => http.get("/dashboard/infografik").then((r) => r.data),
  meta: () => http.get("/meta").then((r) => r.data),

  tetapan: () => http.get("/tetapan").then((r) => r.data),
  simpanTetapan: (b) => http.put("/tetapan", b).then((r) => r.data),

  listDaerah: (params) => http.get("/daerah", { params }).then((r) => r.data),
  statusPemetaan: () => http.get("/pemetaan").then((r) => r.data),
  listOrang: (params) => http.get("/orang", { params }).then((r) => r.data),
  sinkronOrang: () => http.post("/orang/sinkron").then((r) => r.data),
  ciptaOrang: (d) => http.post("/orang", d).then((r) => r.data),
  kemasOrang: (id, d) => http.put(`/orang/${id}`, d).then((r) => r.data),
  tambahInteraksi: (id, d) => http.post(`/orang/${id}/interaksi`, d).then((r) => r.data),

  listPrograma: (params) => http.get("/programa", { params }).then((r) => r.data),
  ciptaPrograma: (d) => http.post("/programa", d).then((r) => r.data),
  kemasPrograma: (id, d) => http.put(`/programa/${id}`, d).then((r) => r.data),
  buangPrograma: (id) => http.delete(`/programa/${id}`).then((r) => r.data),

  aiStatus: () => http.get("/ai/status").then((r) => r.data),
  aiKategoriAduan: (d) => http.post("/ai/kategori-aduan", d).then((r) => r.data),
  aiRingkasNota: (d) => http.post("/ai/ringkas-nota", d).then((r) => r.data),
  aiIsuBerulang: (hari) => http.get("/ai/isu-berulang", { params: { hari } }).then((r) => r.data),
  setPemetaanDaerah: (id, dm_kod) =>
    http.patch(`/daerah/${id}/pemetaan`, { dm_kod }).then((r) => r.data),
  getDaerah: (id) => http.get(`/daerah/${id}`).then((r) => r.data),
  createDaerah: (b) => http.post("/daerah", b).then((r) => r.data),
  updateDaerah: (id, b) => http.put(`/daerah/${id}`, b).then((r) => r.data),
  deleteDaerah: (id) => http.delete(`/daerah/${id}`).then((r) => r.data),

  listMasalah: (params) => http.get("/masalah", { params }).then((r) => r.data),
  createMasalah: (b) => http.post("/masalah", b).then((r) => r.data),
  updateMasalah: (id, b) => http.put(`/masalah/${id}`, b).then((r) => r.data),
  patchStatus: (id, status) =>
    http.patch(`/masalah/${id}/status`, { status }).then((r) => r.data),
  patchLokasi: (id, lat, lng) =>
    http.patch(`/masalah/${id}/lokasi`, { lat, lng }).then((r) => r.data),
  deleteMasalah: (id) => http.delete(`/masalah/${id}`).then((r) => r.data),

  listPengguna: () => http.get("/pengguna").then((r) => r.data),
  createPengguna: (b) => http.post("/pengguna", b).then((r) => r.data),
  updatePengguna: (id, b) => http.put(`/pengguna/${id}`, b).then((r) => r.data),
  deletePengguna: (id) => http.delete(`/pengguna/${id}`).then((r) => r.data),

  listLog: (params) => http.get("/log", { params }).then((r) => r.data),

  kronologi: (id) => http.get(`/masalah/${id}/kronologi`).then((r) => r.data),
  tambahNota: (id, b) => http.post(`/masalah/${id}/nota`, b).then((r) => r.data),

  tracker: (rujukan) => http.get(`/masalah/rujukan/${rujukan}`).then((r) => r.data),
  setPeringkat: (id, b) => http.patch(`/masalah/${id}/peringkat`, b).then((r) => r.data),
  setTugasan: (id, b) => http.patch(`/masalah/${id}/tugasan`, b).then((r) => r.data),
  listLampiran: (id) => http.get(`/masalah/${id}/lampiran`).then((r) => r.data),
  tambahLampiran: (id, b) => http.post(`/masalah/${id}/lampiran`, b).then((r) => r.data),
  buangLampiran: (id, lid) => http.delete(`/masalah/${id}/lampiran/${lid}`).then((r) => r.data),
  kanban: (params) => http.get("/kanban", { params }).then((r) => r.data),

  prestasi: () => http.get("/prestasi").then((r) => r.data),
  geografi: () => http.get("/geografi").then((r) => r.data),
  sempadan: () => http.get("/geografi/sempadan").then((r) => r.data),
  sumberData: () => http.get("/sumber-data").then((r) => r.data),
  listRakyat: (params) => http.get("/rakyat", { params }).then((r) => r.data),
  getRakyat: (kunci) => http.get(`/rakyat/${encodeURIComponent(kunci)}`).then((r) => r.data),

  /* Portal Komuniti (awam, tanpa log masuk) */
  pilihanPortal: () => http.get("/awam/pilihan-portal").then((r) => r.data),
  hantarBantuan: (d) => http.post("/awam/bantuan", d).then((r) => r.data),
  programAwam: (params) => http.get("/awam/program", { params }).then((r) => r.data),
  daftarProgram: (id, d) => http.post(`/awam/program/${id}/daftar`, d).then((r) => r.data),
  daftarSukarelawan: (d) => http.post("/awam/sukarelawan", d).then((r) => r.data),
  hantarCadangan: (d) => http.post("/awam/cadangan", d).then((r) => r.data),

  /* Kotak cadangan (dalaman) */
  listCadangan: (params) => http.get("/cadangan", { params }).then((r) => r.data),
  setStatusCadangan: (id, status) =>
    http.patch(`/cadangan/${id}`, { status }).then((r) => r.data),
  buangCadangan: (id) => http.delete(`/cadangan/${id}`).then((r) => r.data),

  /* Command Center, Komitmen, Tugasan, Agensi */
  kesihatan: () => http.get("/kesihatan").then((r) => r.data),
  kesBerisiko: () => http.get("/kes-berisiko").then((r) => r.data),
  listKomitmen: (params) => http.get("/komitmen", { params }).then((r) => r.data),
  ciptaKomitmen: (d) => http.post("/komitmen", d).then((r) => r.data),
  kemasKomitmen: (id, d) => http.put(`/komitmen/${id}`, d).then((r) => r.data),
  buangKomitmen: (id) => http.delete(`/komitmen/${id}`).then((r) => r.data),
  listTugasan: (params) => http.get("/tugasan", { params }).then((r) => r.data),
  ciptaTugasan: (d) => http.post("/tugasan", d).then((r) => r.data),
  kemasTugasan: (id, d) => http.put(`/tugasan/${id}`, d).then((r) => r.data),
  buangTugasan: (id) => http.delete(`/tugasan/${id}`).then((r) => r.data),
  prestasiAgensi: () => http.get("/agensi").then((r) => r.data),
  rujukAgensi: (id, d) => http.patch(`/masalah/${id}/rujuk-agensi`, d).then((r) => r.data),
  responsAgensi: (id, catatan) =>
    http.patch(`/masalah/${id}/respons-agensi`, { catatan }).then((r) => r.data),

  tukarKataLaluan: (lama, baru) =>
    http
      .post("/auth/tukar-kata-laluan", { kata_laluan_lama: lama, kata_laluan_baru: baru })
      .then((r) => r.data),

  exportUrl: (params) => {
    const qs = new URLSearchParams(
      Object.entries(params || {}).filter(([, v]) => v && v !== "semua")
    ).toString();
    return `${API}/masalah/export.csv${qs ? `?${qs}` : ""}`;
  },
};

export const lampiranUrl = (id) => `${API}/lampiran/${id}`;

export const errMsg = (e) =>
  e?.response?.data?.detail || e?.message || "Ralat tidak diketahui";

/* Pautan WhatsApp dengan mesej siap taip */
export const waLink = (telefon, mesej) => {
  const digit = String(telefon || "").replace(/[^0-9]/g, "");
  if (!digit) return null;
  const nombor = digit.startsWith("60") ? digit : `60${digit.replace(/^0+/, "")}`;
  return `https://wa.me/${nombor}?text=${encodeURIComponent(mesej)}`;
};

export const mesejPengadu = (m) => {
  const ayat =
    {
      Baru: "Aduan telah diterima dan sedang disemak.",
      "Dalam Tindakan": "Aduan kini dalam tindakan bersama agensi berkaitan.",
      Selesai: "Aduan telah selesai.",
    }[m.status] || "Aduan tuan atau puan sedang kami uruskan.";
  const penuh = m.no_rujukan ? `${m.no_rujukan}${m.kod_semak ? `-${m.kod_semak}` : ""}` : "";
  const ruj = penuh ? `\nNo rujukan: ${penuh}` : "";
  const semak = penuh
    ? `\n\nSemak status pada bila bila masa: ${window.location.origin}/semak?rujukan=${penuh}`
    : "";
  return `Salam. Pasukan Kamil Munim, P.061 Padang Rengas.\n\nAduan: ${m.tajuk}${ruj}\nDaerah: ${m.daerah_nama || ""}\nStatus: ${m.status}\n\n${ayat}${semak}`;
};

export const mesejAgensi = (m) =>
  `Salam. Pasukan Kamil Munim, P.061 Padang Rengas.\n\nMohon tindakan bagi aduan berikut:\nNo rujukan: ${m.no_rujukan || "-"}\nIsu: ${m.tajuk}\nDaerah: ${m.daerah_nama || ""}\nKategori: ${m.kategori}\nKeutamaan: ${m.keutamaan}\nTempoh SLA: ${m.sla_hari || "-"} hari (umur aduan ${m.hari_umur ?? "-"} hari)\nKos anggaran: RM ${Number(m.kos_anggaran || 0).toLocaleString("ms-MY")}`;
